import React from 'react'
import PropTypes from 'prop-types'
import SortableList from '../sortableList/SortableList'
import LayoutSelector from '../layoutSelector/LayoutSelector'

const BrowseOptions = props => {
  let sortableList
  if (props.order && props.showSortableList) {
    sortableList = (
      <div className='sortable-list-container pull-right'>
        <SortableList
          sortableFields={['rank', 'az', 'date']}
          order={props.order}
          onSort={props.onSort}
        />
      </div>
    )
  }

  let layoutSelector
  if (props.layout) {
    layoutSelector = (
      <LayoutSelector onSelect={props.selectLayout} layout={props.layout} />
    )
  }
  return (
    <div className='browse-options'>
      {sortableList}
      {layoutSelector}
    </div>
  )
}

BrowseOptions.propTypes = {
  onSort: PropTypes.func,
  order: PropTypes.string,
  layout: PropTypes.string,
  selectLayout: PropTypes.func,
  showSortableList: PropTypes.bool
}

export default BrowseOptions
